var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditMainInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44771 14.2189L14.219 6.44771C14.5824 6.08421 14.7642 5.90247 14.8614 5.7064C15.0462 5.33337 15.0462 4.8954 14.8614 4.52236C14.7642 4.3263 14.5824 4.14455 14.219 3.78105C13.8554 3.41755 13.6737 3.2358 13.4776 3.13864C13.1046 2.95379 12.6666 2.95379 12.2936 3.13864C12.0975 3.2358 11.9158 3.41755 11.5523 3.78105L3.78105 11.5523C3.39567 11.9376 3.20299 12.1303 3.10149 12.3753C3 12.6203 3 12.8929 3 13.4379V14.9999H4.56209C5.1071 14.9999 5.3796 14.9999 5.62463 14.8985C5.86965 14.797 6.06234 14.6043 6.44771 14.2189Z",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H13",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 4.6665L13.3333 7.33317",
    stroke: "#212129",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMainInfo);
export default __webpack_public_path__ + "static/media/edit_main_info.73cb77f2e09de5be71862a223779ade1.svg";
export { ForwardRef as ReactComponent };